import React from 'react';
import PropTypes from 'prop-types';
import {connectToStores} from 'epic-alt-utils/index';
import SectionSwiper from '../../components/sectionSwiper/SectionSwiper';
import EpicGamesFooterWrapper from '../../components/footer/Footer';
import MapsSectionBlock from '../../components/maps/MapsSectionBlock';
import MetaTags from '../../components/common/MetaTags';
import {MapsStore, LoginStore, LocalizationStore, FooterStore} from '../../stores';

@connectToStores
export default class MapsView extends React.Component {
    static getStores() {
        return [MapsStore, LoginStore, LocalizationStore, FooterStore];
    }

    static getPropsFromStores() {
        return {
            mapsData: MapsStore.getState(),
            loginStore: LoginStore.getState(),
            localizationStore: LocalizationStore.getState(),
            footerStore: FooterStore.getState()
        };
    }
    static propTypes = {
        mapsData: PropTypes.object,
        loginStore: PropTypes.object,
        localizationStore: PropTypes.object,
        footerStore: PropTypes.object,
        match: PropTypes.object
    };

    render() {
        const {
            mapsData,
            loginStore,
            footerStore,
            localizationStore
        } = this.props;
        const {
            _title,
            titanBlock,
            facingBlock,
            outpostBlock
        } = mapsData.data;
    
        return (
            <div className="MapsView">
                <MetaTags meta={{title: _title}} />
                <SectionSwiper
                    sections={[
                        {
                            component: MapsSectionBlock,
                            props: { block: titanBlock }
                        },
                        {
                            component: MapsSectionBlock,
                            props: { block: facingBlock }
                        },
                        {
                            component: MapsSectionBlock,
                            props: { block: outpostBlock }
                        },
                        {
                            component: EpicGamesFooterWrapper,
                            props: { loginStore, footerStore, localizationStore },
                            adpativeHeight: true,
                            hasUpOnClickProp: true
                        }
                    ]} />
            </div>
        );
    }
}
